<!--
  El botón NO entra en el orden de tabulación de la tabla por accidente: lleva su nombre accesible
  para que quien navegue con teclado o lector sepa qué va a abrir antes de abrirlo.
-->
<button type="button" class="ay-btn" [attr.aria-label]="titulo" (click)="ayuda.toggle($event)">
  <i class="fa-solid fa-circle-question"></i>
</button>

<!--
  Sin X: el círculo oscuro de PrimeNG se sale del panel y no es de esta plataforma. Se cierra
  haciendo clic fuera o con Escape, igual que el del embudo.
-->
<p-overlayPanel #ayuda styleClass="ay-panel" appendTo="body">
  <div class="ay-body">
    <h4>{{ titulo }}</h4>
    <ng-content></ng-content>
  </div>
</p-overlayPanel>
